<template>
  <div class="shippingSelectForm" style="margin-top: 1rem;margin-bottom:1.5rem;"  v-if="shippingList && shippingList.length>1" >
    <div class="form-select">
      <SfSelect v-model="addressId"  :label="laebl"  class="form__element form__select"
        :valid="true" :errorMessage="''"  @input="changeShipping" >
        <!-- @input="($event)=>changeShipping($event)"  -->
        <SfSelectOption v-for="shipping in shippingList" :key="shipping.addressId"
          :value="shipping.addressId" :data="shipping">
          <template v-if="shipping.addressId === '-1'">{{ $t('Add_new_address') }}</template>
          <template v-else>
          {{ (shipping.firstName +''+ shipping.lastName  +' '+ shipping.phoneNumber)  +' '+ (shipping.state + shipping.streetName) }}
          </template>
        </SfSelectOption>
      </SfSelect>
    </div>
  </div>
</template>
<script>
import {
  SfSelect
} from '@storefront-ui/vue';
import { useShipping } from '@bee-hole/coms';
import { ref, useRouter, computed, onMounted } from '@nuxtjs/composition-api';
import { onSSR } from "@vue-storefront/core";
export default {
  name: 'ShippingSelect',
  setup(props, context) {
    const { load: loadShippingAddress, loading, shipping: shippingResult } = useShipping();
    const addressId = ref();
    const shippingList = computed(() => {
      let list = [...(shippingResult.value?.list || [])];
      list.unshift({
        addressId: '-1',
        state: context.root.$t('Add_new_address'),
        streetName: ''
      });
      return list;
    })
    const changeShipping = (id) => {
      if (id) {
        const shipping = shippingList.value.find((item) => item.addressId.toString() === addressId.value.toString());
        context.emit('backShipping', shipping);
      } else {
        context.emit('backShipping', {
          addressId: '-1'
        });
      }
    };
    onSSR(() => {
      // loadShippingAddress();
    });
    onMounted(async () => {
      await loadShippingAddress({ limit: 1,
        page: 100 });
      if (shippingResult.value?.list && shippingResult.value?.list?.length > 0) {
        addressId.value = shippingResult.value.list[0].addressId.toString();
        changeShipping(addressId.value);
      } else {
        addressId.value = '-1';
        changeShipping(addressId.value);
      }
    });
    return {
      shippingList,
      addressId,
      changeShipping,
      laebl: context.root.$t('Shipping_details')
    };
  },
  components: {
    SfSelect
  }
};
</script>
<style lang="scss">
.shippingSelectForm{
//  display: grid;
//     gap: 1rem;
    // @include for-desktop {
    //   grid-template-columns: repeat(2, 1fr);
    //   //  grid-template-columns: 1fr 1fr;
    //   .full-width {
    //       grid-column: 1 / -1;
    //   }
    //   // 3个一列
    //   .three-column {
    //     grid-column: 1 / -1;
    //     display: grid;
    //     grid-template-columns: 1fr 1fr 1fr;
    //     gap: 1rem;
    //   }
    // }
    // .sf-input__error-message{
    //   min-height: 0;
    // };
    // .form__select {
    //   padding: 1rem 0;
    // }
    // .form__element {
    //   margin: 0 0 0 0;
    //   @include for-desktop {
    //     flex: 0 0 100%;
    //   }
    //   &--half {
    //     @include for-desktop {
    //       flex: 1 1 50%;
    //     }

    //     &-even {
    //       @include for-desktop {
    //         // padding: 0 0 0 var(--spacer-xl);
    //       }
    //     }
    //   }

    // };
    .form-select{
       // border-bottom: 0 !important;
        border: 1px solid var(--c-text);
        padding: 0;
        padding-left:0.5rem;
        height: 45px;
        margin-bottom:0;
        // .sf-select{
        //   padding-top: 0;
        // }
        .sf-select__label{
          // position: relative;
          width: 100%;
          text-align: left;
          top: 1rem;
          // padding-left: 0;
          position: relative;
        }
    }
     .form__select{
        padding-top: 0.75rem;
      }
      .sf-input__label{
        top: 60%;
        left: 0.5rem;
        color: var(--c-secondary-variant)
      }
    .sf-select__dropdown{
      border-bottom: 0 !important;
      padding-top: 0 !important;
    }
    // .col-column2{
    //   grid-column: 2;
    // }
    // .col-column1{
    //   grid-column: 1;
    // }
}

</style>
